import React, { useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody } from './../../components/card/card.jsx';
import { AppSettings } from './../../config/app-settings.js';

function Perplexed() {
	const context = useContext(AppSettings);
	const navigate = useNavigate();
	
	function handleBackBtn() {
		navigate(-1);
	}
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);

	return (
		<div className="error-page">
			<div className="error-page-content">
				<Card className="mb-5 mx-auto" style={{maxWidth: '320px'}}>
					<CardBody>
						<Card>
							<div className="error-code">AI</div>
						</Card>
					</CardBody>
				</Card>
				<h1>We Love Generative AI</h1> 
				<div>
					Generative AI has the potential to revolutionize businesses by automating creative tasks,<br />
					personalizing customer experiences, and generating innovative solutions for complex problems.<br />
					It can enhance productivity, reduce costs, and open new avenues for growth by transforming how<br />
					content is created, decisions are made, and services are delivered.
				</div>
				<hr />
				<p className="mb-1">
					Here are some helpful links:
				</p>
				<p className="mb-5" style={{ marginTop: '10px' }}>
					<Link to="/" className="text-decoration-none text-inverse text-opacity-50">Home</Link>
					<span className="link-divider"></span>
					<Link to="/mastercloserai" className="text-decoration-none text-inverse text-opacity-50">Master Closer AI</Link>
					<span className="link-divider"></span>
					<Link to="/chat/aiservices" className="text-decoration-none text-inverse text-opacity-50">AI Chatbot</Link>
				</p>
				<button onClick={handleBackBtn} className="btn btn-outline-theme px-3 rounded-pill"><i className="fa fa-arrow-left me-1 ms-n1"></i> Go Back</button>
			</div>
		</div>
	)
}

export default Perplexed;